<template>
  <div
    :inert="active"
    class="border-1 group/catalog-card shadow-around relative flex cursor-pointer items-center gap-2 rounded-lg border-neutral-100 bg-white px-2 py-1.5 shadow-gray-400/20 shadow-neutral-300/40 dark:border-neutral-800/70 dark:bg-neutral-800/50 dark:shadow-none"
    :class="{
      'ring-primary active ring-2': active,
      'hover:ring-1 hover:ring-neutral-200 dark:hover:ring-neutral-700':
        !active,
      'flex-col': view == 'card',
      // : view == 'card'
    }"
    @click="openCatalog()"
  >
    <div
      :class="{
        'size-20': view == 'list',
        'h-45 w-full': view == 'card',
      }"
      class="shrink-0"
    >
      <LazyImage
        :url="catalog?.media"
        class="[.loaded]:bg-white [.error]:bg-gray-100 [.error]:dark:bg-neutral-800 h-full w-full rounded"
        image-class="object-cover h-full w-full"
      />
    </div>
    <div class="w-full pe-2">
      <h3 class="mb-1 line-clamp-2 w-full text-base leading-[1.2]">
        {{ catalog.name }}
      </h3>
      <p
        class="mb-1 line-clamp-1 w-full text-sm font-semibold text-gray-400 dark:text-neutral-400"
      >
        {{ catalog.address }}
      </p>
      <div class="flex items-center justify-between text-sm">
        <span class="text-gray-500 dark:text-neutral-400"
          >{{ $t('titles.Available') }}: {{ catalog.free_count }}</span
        >
        <span>
          {{ $t('control.from') }}
          {{
            $formatCompactCurrency(
              catalog.min_price * 1,
              catalog.currency,
              $i18n.locale
            )
          }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import LazyImage from '@/components/ui/LazyImage';

export default {
  name: 'CatalogCardMini',
  components: {
    LazyImage,
  },
  props: {
    catalog: {
      type: Object,
      required: true,
    },
    view: {
      type: String,
      default: 'list',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['catalogSettings']),
    active() {
      return (
        this.catalogSettings.type == 'InteractiveCatalogue' &&
        this.catalogSettings.id == this.catalog.id
      );
    },
  },
  methods: {
    ...mapActions(['CLOSE_MODAL']),

    openCatalog() {
      this.$router.push({
        name: 'Main',
        params: {
          firstToken: this.$route.params.firstToken,
          secondToken: this.catalog.token,
        },
      });
      this.CLOSE_MODAL();
    },
  },
};
</script>
<style lang="scss"></style>
